var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('analytics-chart-wrapper',{attrs:{"title":_vm.title,"chart-class":"campaignsChart","chart":_vm.chart,"settings":_vm.settings,"options":_vm.options,"items":_vm.items,"export-table-method":_vm.exportTableMethod}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce5b6858","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/analytics/components/CampaignsChart.vue
// module id = null
// module chunks = 